import React from "react";
import { Layout, Row } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const Loader = () => {
  return (
    <Layout>
      <Row justify="center" align="middle" className="page_content">
        <LoadingOutlined/>
      </Row>
    </Layout>
  );
};
